(() => {
  const mobileDrawer = document.querySelector(".js-mobile-menu-drawer");

  const openDrawer = document.querySelector(".js-open-mobile-menu-drawer");

  const closeDrawerBtn = document.querySelector(".js-mobile-menu-header-close");

  const grandDadMenu = document.querySelector(".js-granddad-mobile-menu");

  function closeDrawerMobileDrawer() {
    document.body.classList.remove("remove-scrolling");

    Array.from(document.querySelectorAll(".mobile-menu-child--show")).forEach(
      (elem) => {
        elem.classList.remove("mobile-menu-child--show");
        elem.classList.add("mobile-menu-child--hide");
        elem.style.maxHeight = `${0}px`;
      }
    );

    grandDadMenu.classList.remove("mobile-menu-child--hide");
    grandDadMenu.classList.add("mobile-menu-child--show");
    grandDadMenu.style.maxHeight = `unset`;
    mobileDrawer.close();
  }

  openDrawer.addEventListener("click", () => {
    mobileDrawer.showModal();
    document.body.classList.add("remove-scrolling");
  });

  closeDrawerBtn.addEventListener("click", () => {
    closeDrawerMobileDrawer();
  });

  mobileDrawer.addEventListener("click", (e) => {
    const dialogDimensions = mobileDrawer.getBoundingClientRect();
    if (
      e.clientX < dialogDimensions.left ||
      e.clientX > dialogDimensions.right ||
      e.clientY < dialogDimensions.top ||
      e.clientY > dialogDimensions.bottom
    ) {
      closeDrawerMobileDrawer();
    }
  });
})();
